// extracted by mini-css-extract-plugin
export default {"order":"Order_order__ZSD9J","data":"Order_data__s7sgu","pro":"Order_pro__Yxsv4"};